import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const ButtonDropdownMultipleHeaderWrapper = styled.div`
  padding-top: ${Spacing.S8};
  padding-left: ${Spacing.S16};
`
